import { render, staticRenderFns } from "./GoPremium.vue?vue&type=template&id=a22c410a&"
import script from "./GoPremium.vue?vue&type=script&lang=js&"
export * from "./GoPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports